export default "__VITE_ASSET__Dloz4XoS__"